"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_DICTATE = void 0;
exports["default"] = startDictate;
var START_DICTATE = 'WEB_CHAT/START_DICTATE';
exports.START_DICTATE = START_DICTATE;

function startDictate() {
  return {
    type: START_DICTATE
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTVEFSVF9ESUNUQVRFIiwic3RhcnREaWN0YXRlIiwidHlwZSJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3N0YXJ0RGljdGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTVEFSVF9ESUNUQVRFID0gJ1dFQl9DSEFUL1NUQVJUX0RJQ1RBVEUnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzdGFydERpY3RhdGUoKSB7XG4gIHJldHVybiB7IHR5cGU6IFNUQVJUX0RJQ1RBVEUgfTtcbn1cblxuZXhwb3J0IHsgU1RBUlRfRElDVEFURSB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsYUFBYSxHQUFHLHdCQUF0Qjs7O0FBRWUsU0FBU0MsWUFBVCxHQUF3QjtFQUNyQyxPQUFPO0lBQUVDLElBQUksRUFBRUY7RUFBUixDQUFQO0FBQ0QifQ==